import React from 'react';
import PriceMatrix from './PriceMatrix';
import PriceMatrixCell from './PriceMatrixCell';
import { productKeyDescription } from '../../data/Utils';

const VendorPrice = (props) => {
  const { group } = props;
  if (!group) return null;

  const { quantities, matrix } = group;
  const leadTimes = group.lead_times;

  if (!quantities || !leadTimes || !matrix) return null;

  return (
    <div className="vendor-group">
      <h4>{productKeyDescription(group.product_key)}</h4>
      <PriceMatrix
        {...props}
        matrix={matrix}
        leadTimes={leadTimes}
        quantities={quantities}
        matrixCell={PriceMatrixCell} />
    </div>
  );
};

export default VendorPrice;
